import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DealBusinessTypeRequest, DealBusinessTypeResponse, NewPageResponse } from '../models/deal-business-type.model';

@Injectable({ providedIn: 'root' })
export class DealBusinessTypeApiService {
  private readonly apiUrl = `${environment.apiUrl}api/deal-business-types`;

  constructor(private http: HttpClient) {}

  getAll(businessId: number, page = 0, size = 20): Observable<NewPageResponse<DealBusinessTypeResponse>> {
    const params = new HttpParams()
      .set('businessId', businessId)
      .set('page', page)
      .set('size', size);
    return this.http.get<NewPageResponse<DealBusinessTypeResponse>>(this.apiUrl, { params });
  }

  getById(id: number, businessId: number): Observable<DealBusinessTypeResponse> {
    const params = new HttpParams().set('businessId', businessId);
    return this.http.get<DealBusinessTypeResponse>(`${this.apiUrl}/${id}`, { params });
  }

  create(req: DealBusinessTypeRequest): Observable<DealBusinessTypeResponse> {
    return this.http.post<DealBusinessTypeResponse>(this.apiUrl, req);
  }

  update(id: number, req: DealBusinessTypeRequest): Observable<DealBusinessTypeResponse> {
    return this.http.put<DealBusinessTypeResponse>(`${this.apiUrl}/${id}`, req);
  }

  delete(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId);
    return this.http.delete<void>(`${this.apiUrl}/${id}`, { params });
  }
}
